import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { HstService } from '../../services/hst.service';
import { catchError, of, tap } from "rxjs";
import {
    DsButtonModule,
    DsFormFieldModule,
    DsLoadingAreaConfiguration,
    DsLoadingAreaService,
    DsSelectModule
} from "@bmw-ds/components";
import { Router } from "@angular/router";
import { FormsModule } from "@angular/forms";

@Component({
    selector: 'app-landing',
    standalone: true,
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    imports: [
        DsFormFieldModule,
        DsSelectModule,
        DsButtonModule,
        FormsModule
    ]
})
export class LandingComponent implements OnInit {
    dealerOptions: { id: string; label: string }[] = [];
    selectedDealer: string | null = null;
    loadingAreaConfig: DsLoadingAreaConfiguration = {
        id: 'bodyLoading',
        loadingTitle: 'Loading...',
    };
    private readonly router = inject(Router);
    private readonly hstService = inject(HstService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly loadingAreaService = inject(DsLoadingAreaService);
    ngOnInit() {
        this.loadDealers();
    }

    loadDealers() {
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
        this.fetchDealers().subscribe({
            next: (dealers) => {
                this.mapToOptions(dealers);
                this.cdr.detectChanges();
            },
            error: (err) => console.error('Failed to load dealers', err),
            complete: () => {
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
            }
        });
    }

    private fetchDealers() {
        const userId = localStorage.getItem('userId') || '';
        const dealerObservable = this.hstService.getUserAgentList(userId)
        return dealerObservable.pipe(
            tap((dealers) => {
                if (dealers && dealers.agentList) {
                    this.mapToOptions(dealers);
                }
            }),
            catchError((error) => {
                console.error('Error fetching dealer list:', error);
                return of([]); // fallback
            })
        );
    }

    private mapToOptions(dealers: any) {
        this.dealerOptions = dealers.agentList?.map((dealer: any) => ({
            id: dealer.code,
            label: `${dealer.name} - ${dealer.code}`,
        })) ?? [];
    }

    enterApp() {
      if (this.selectedDealer) {
        let dealerCode = this.selectedDealer;
        if (/^\d{4}$/.test(dealerCode)) {
          dealerCode = '0' + dealerCode;
        }
        localStorage.setItem('dealerCode', dealerCode);
        this.router.navigate(['/stock-unit-search']);
      }
    }
}
